import { useState } from 'react'

export function useSettings() {
  const [autoDowngrade, setAutoDowngrade] = useState(true)
  const [allowSlowWorkers, setAllowSlowWorkers] = useState(true)
  const [allowNSFW, setAllowNSFW] = useState(false)
  const [promptFilter, setPromptFilter] = useState(true)
  const [trustedWorkers, setTrustedWorkers] = useState(false)
  const [karras, setKarras] = useState(true)
  const [tiling, setTiling] = useState(false)
  const [hiresFix, setHiresFix] = useState(false)
  const [stripBackground, setStripBackground] = useState(false)
  const [transparentBackground, setTransparentBackground] = useState(false)
  const [faceFixerMethod, setFaceFixerMethod] = useState<'GFPGAN'|'CodeFormers'>('GFPGAN')
  const [faceFixerStrength, setFaceFixerStrength] = useState(0.75)
  const [steps, setSteps] = useState(30)
  const [cfgScale, setCfgScale] = useState(8.5)
  const [clipSkip, setClipSkip] = useState(2)
  const [width, setWidth] = useState(512)
  const [height, setHeight] = useState(512)

  const [selectedSampler, setSelectedSampler] = useState('DDIM')

  const handleHordeSettingChange = (key: string, value: boolean) => {
    switch (key) {
      case 'autoDowngrade': setAutoDowngrade(value); break
      case 'allowSlowWorkers': setAllowSlowWorkers(value); break
      case 'allowNSFW': setAllowNSFW(value); break
      case 'promptFilter': setPromptFilter(value); break
      case 'trustedWorkers': setTrustedWorkers(value); break
      case 'karras': setKarras(value); break
      case 'tiling': setTiling(value); break
      case 'hiresFix': setHiresFix(value); break
      case 'stripBackground': setStripBackground(value); break
      case 'transparentBackground': setTransparentBackground(value); break
    }
  }

  const handleParamChange = (key: string, value: number) => {
    switch (key) {
      case 'steps': setSteps(value); break
      case 'cfgScale': setCfgScale(value); break
      case 'clipSkip': setClipSkip(value); break
      case 'width': setWidth(value); break
      case 'height': setHeight(value); break
      case 'faceFixerStrength': setFaceFixerStrength(value); break
    }
  }

  return {
    autoDowngrade, allowSlowWorkers, allowNSFW, promptFilter, trustedWorkers,
    karras, tiling, hiresFix, stripBackground, transparentBackground,
    faceFixerMethod, faceFixerStrength, steps, cfgScale, clipSkip, width, height,
    selectedSampler, setSelectedSampler,
    handleHordeSettingChange, handleParamChange,
    setKarras, setTiling, setHiresFix, setStripBackground, setTransparentBackground,
    setFaceFixerMethod, setFaceFixerStrength, setSteps, setCfgScale, setClipSkip, setWidth, setHeight
  }
}
